import React from 'react'
import Navbar from '../HomePage/Navbar'
import Footer from '../HomePage/Footer'
import Terms from './Terms'
function TermsIndex() {
  return (
    <div  style={{fontFamily:"Poppins, sans-serif"}}>
      <Navbar />
      <Terms />
      <Footer />
    </div>
  )
}

export default TermsIndex
